import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import { API_USER_OPERATION_LIST, type ApiBoCheckRightRes } from "./types";

interface BoCheckRightsResponse {
    checkRightsResults: ApiBoCheckRightRes[];
}

/**
 * Транспортный слой OMP — проверка прав на БО.
 */
export const boRightsApi = {
    /**
     * Выполняет raw-запрос проверки прав для БО.
     * Запрос уходит в endpoint `bo.checkRights`.
     * @param params код БО и список кодов проверяемых действий
     * @param config конфигурация HTTP-запроса
     * @returns результаты проверки прав по каждой операции
     */
    check: async (
        params: {
            boCode: number;
            rightCodes: API_USER_OPERATION_LIST[];
        },
        config?: RequestConfig,
    ): Promise<ApiBoCheckRightRes[]> => {
        const data = await ompApiClient.postOmega<BoCheckRightsResponse>(
            "bo.checkRights",
            {
                boCodes: [params.boCode],
                actionCodes: params.rightCodes,
            },
            config,
        );
        return data.checkRightsResults;
    },
} as const;
